import { render, staticRenderFns } from "./static.vue?vue&type=template&id=6660b2f3&scoped=true&"
import script from "./static.vue?vue&type=script&lang=js&"
export * from "./static.vue?vue&type=script&lang=js&"
import style0 from "./static.vue?vue&type=style&index=0&id=6660b2f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6660b2f3",
  null
  
)

export default component.exports